<section class="py-5">
  <div class="container support-form">
    <div class="row">
       <div class="pricing-header mb-4 p-3 pb-md-4 mx-auto text-center">
        <h1 class="display-4 fw-bold mb-3 text-body-emphasis">Help When You Need It</h1>
        <p class="fs-5 text-secondary">
        Find quick answers to your questions or get in touch with our team, we’re here to support your creative journey.
        </p>
      </div>

      <div class="mb-5">
        
        <div class="text-left">
          <h4 class="fw-bold">Submit a request</h4>
        </div>

        <form class="form" role="form" [formGroup]="categoryContent" #f="ngForm" *ngIf="categoryContent" 
        (ngSubmit)="submitContent(categoryContent.value, categoryContent.valid)">
          <select
            class="boxz search-boxz p-3 mt-3 form-select rounded-3"
            aria-label="Select Category"
            formControlName="category"
          >
            <option value="" disabled selected>Select Category</option>
            <option value="Password/Login issues">Password/Login issues</option>
            <option value="Usage/ License Query">Usage/ License Query</option>
            <option value="Copyright">Copyright</option>
            <option value="Suggestion">Suggestion</option>
            <option value="Other">Other</option>
          </select>

          <div class="mt-3 form-floating mb-3">
            <input
              type="email"
              class="form-control rounded-3"
              id="floatingInput"
              placeholder="name@example.com"
              formControlName="emailId"
            />
            <label for="floatingInput">Email address</label>
          </div>

          <div class="form-floating">
            <textarea
              class="form-control rounded-3"
              placeholder="Leave a comment here"
              id="floatingTextarea2"
              style="height: 200px"
              formControlName="message"
            ></textarea>
            <label for="floatingTextarea2">Write us a message</label>
          </div>

          <p class="mt-3 fw-small-xx">
            <small>
              Please enter the details of your request and, if you have any
              questions regarding our Terms of Use, If you’re reporting a
              problem, make sure to include as much information as possible.
              Once your request is submitted, a member of our support staff will
              respond as soon as possible.
            </small>
          </p>

          <p class="mt-3 fw-small-xx">
            <strong>Basic information on Data Protection: </strong>
            <small>
              Illusbook collects your data to be able to answer to questions,
              suggested, or complaints filed.
              <a class="fw-semi text-red" href="">Privacy Policy</a>
            </small>
          </p>

          <div class="mt-4">
            <button #submitBtn type="submit" class="w-100 btn btn-ib-black px-4 me-sm-3 rounded-3">
              <i class="far fa-envelope"></i>&nbsp;Send us a message
            </button>
          </div>
        </form>
        <div class="alert alert-success" role="alert" *ngIf="message" >
          {{message}}
        </div>
      </div>


      <h3 class="display-6 fw-bold text-center mb-4">Frequently Asked Questions</h3>

    <div class="accordion mb-5" id="accordionExample">
      <div class="accordion-item mb-4">
        <h2 class="accordion-header">
          <button class="accordion-button fs-5 collapsed" type="button" data-bs-toggle="collapse"
            data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
           I’m having trouble downloading an illustration. What should I do?
          </button>
        </h2>
        <div id="collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
          <div class="accordion-body text-secondary">
            Make sure you're logged into your account. If the issue persists, try refreshing the page or switching browsers. If it still doesn’t work, contact us at
             <a class="un-link" href="mailto:support@illusbook.com">support&#64;illusbook.com</a>
          </div>
        </div>
      </div>
      <div class="accordion-item mb-3">
        <h2 class="accordion-header">
          <button class="accordion-button fs-5 collapsed" type="button" data-bs-toggle="collapse"
            data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
            I forgot my password. How can I reset it?
          </button>
        </h2>
        <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
          <div class="accordion-body text-secondary">
            Click on the <a class="un-link " routerLink="/forgot-password">“Forgot Password?”</a> link on the login page. You’ll receive a password reset link in your email.
          </div>
        </div>
      </div>
      <div class="accordion-item mb-3">
        <h2 class="accordion-header">
          <button class="accordion-button fs-5 collapsed" type="button" data-bs-toggle="collapse"
            data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
            Can I access Illusbook from mobile devices?
          </button>
        </h2>
        <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
          <div class="accordion-body text-secondary">
            Yes! Illusbook is fully responsive and works smoothly on mobile phones, tablets, and desktops.
          </div>
        </div>
      </div>
      <div class="accordion-item mb-3">
        <h2 class="accordion-header">
          <button class="accordion-button fs-5 collapsed" type="button" data-bs-toggle="collapse"
            data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
            How do I upgrade to the Pro plan?
          </button>
        </h2>
        <div id="collapseFour" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
          <div class="accordion-body text-secondary">
           You can upgrade anytime from your subscription page or visiting the Pricing page and choosing the Pro plan.
          </div>
        </div>
      </div>

      <div class="accordion-item mb-3">
        <h2 class="accordion-header">
          <button class="accordion-button fs-5 collapsed" type="button" data-bs-toggle="collapse"
            data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
            Is there customer support available?
          </button>
        </h2>
        <div id="collapseFive" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
          <div class="accordion-body text-secondary">
           Yes. We typically respond within a few hours. You can reach out via email or use the contact form on our Support page.
          </div>
        </div>
      </div>

      <div class="accordion-item mb-3">
        <h2 class="accordion-header">
          <button class="accordion-button fs-5 collapsed" type="button" data-bs-toggle="collapse"
            data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
            Where can I find my downloaded illustrations?
          </button>
        </h2>
        <div id="collapseSix" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
          <div class="accordion-body text-secondary">
           Downloads are stored in your browser’s default Downloads folder. You can also check your Illusbook account’s download history.
          </div>
        </div>
      </div>

      <div class="accordion-item mb-3">
        <h2 class="accordion-header">
          <button class="accordion-button fs-5 collapsed" type="button" data-bs-toggle="collapse"
            data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
            Can I request a refund?
          </button>
        </h2>
        <div id="collapseSeven" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
          <div class="accordion-body text-secondary">
           Refunds are handled case-by-case. Please refer to <a class="un-link" routerLink="/refund">our Refund Policy</a> for more details or reach out to support.
          </div>
        </div>
      </div>

      <div class="accordion-item mb-3">
        <h2 class="accordion-header">
          <button class="accordion-button fs-5 collapsed" type="button" data-bs-toggle="collapse"
            data-bs-target="#collapseEight" aria-expanded="false" aria-controls="collapseEight">
           Do you offer custom illustrations?
          </button>
        </h2>
        <div id="collapseEight" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
          <div class="accordion-body text-secondary">
           Yes, but only for Pro users. You can submit a request once you upgrade.
          </div>
        </div>
      </div>

    </div>
    </div>
  </div>
</section>

